/*
 * @Author: Json Chen
 * @Date: 2022-06-17 16:37:10
 * @Description:
 * @FilePath: /unifyxp-v2-store-portal/src/components/DeletePopconfirm/DeletePopconfirm.tsx
 */
import { DeleteOutlined } from '@ant-design/icons';
import { Popconfirm } from 'antd';
import React from 'react';
import GlobalButton from '../Antd/Button/Button';
import css from './DeletePopconfirm.less';
import { useI18n } from 'src/hooks/useRouterChange';
import { i18nGet } from 'src/tools/tools';

interface IProps {
  title;
  confirm;
  btnClassName?;
  size?;
  type?;
  children?;
  popoverWidth?: number;
  disabled?: boolean;
  getPopupContainer?;
}

const DeletePopconfirm = (props: IProps) => {
  const i18n = useI18n();
  const getI18n = (str) => i18nGet(i18n, str);

  const {
    title,
    confirm,
    btnClassName,
    size,
    type,
    children,
    disabled,
    ...others
  } = props;

  return (
    <Popconfirm
      {...others}
      title={title}
      placement='topRight'
      onConfirm={() => confirm()}
      overlayClassName={css.popconfirm}
      okText={getI18n('general.delete')}
      disabled={disabled}
      okButtonProps={{ danger: true }}
      cancelText={getI18n('general.cancel')}>
      {children ? (
        children
      ) : (
        <GlobalButton
          className={btnClassName || ''}
          type={type}
          size={size}
          disabled={disabled}>
          <DeleteOutlined />
        </GlobalButton>
      )}
    </Popconfirm>
  );
};
export default DeletePopconfirm;
